<div>
  <p>The customer portal gives access to:</p>
  <ul>
    <li>Details of your purchased systems</li>
    <li>Renewal of hardware warranty and software maintenance plans</li>
    <li>Download the latest drivers, software and documentation</li>
  </ul>
</div>

<div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()" autocomplete="off" novalidate>
    <div class="form-fields">
      <!-- New Password Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" required data-lpignore="true" autocomplete="email" />

        @if (email.hasError("required")) {
          <mat-error> Email Required </mat-error>
        } @else if (email.hasError("email")) {
          <mat-error> Invalid Email </mat-error>
        }
      </mat-form-field>

      <!-- Confirm Password Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" required data-lpignore="true" autocomplete="new-password" />

        @if (password.hasError("required")) {
          <mat-error> Password Required </mat-error>
        } @else if (password.hasError("strongPassword")) {
          <mat-error> Password must be at least 8 characters long and include a letter, a number, and a special character. </mat-error>
        }
      </mat-form-field>

      <!-- Submit Button -->
      <div class="submit-btn-wrapper login-btn">
        <!-- Create User -->
        <button mat-flat-button type="submit" [disabled]="form.invalid || saveState()">Login</button>
      </div>
    </div>
  </form>
</div>

<div>
  <div>
    <p>
      <a [routerLink]="['/', routesConst.login, routesConst.forgotPassword]" [queryParams]="{ email: form.value.email }">Forgot your password?</a>
    </p>
  </div>
  <div>Don't have a Speedgoat Account? <a href="/my-account/create-account">Create an account</a></div>
</div>

@if (apiErrorMessage()) {
  <div class="alert-danger" style="margin-top: 24px">
    Login Error, Please check your credentials and try again.
    <!-- {{ apiErrorMessage() }} -->
  </div>
}
